export const usmle2ObgynModule = {
  id: "obgyn",
  title: "OB/GYN",
  sections: [
    {
      type: "text",
      content:
        "Preeclampsia: hypertension after 20 weeks with proteinuria or end-organ signs.",
    },
    {
      type: "question",
      text: "Seizures in a pregnant patient with preeclampsia indicates:",
      options: ["Eclampsia", "HELLP", "Hyperemesis", "Chorioamnionitis"],
      correct: 0,
      explanation: "Eclampsia is preeclampsia with seizures.",
    },
  ],
};
